import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '.abyss-descriptors-error-message': {
    marginTop: '12px',
    position: 'static',
  },
});
